// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__8ewws","slider":"ToggleSwitch_slider__r3uu-","round":"ToggleSwitch_round__ZZ1Re"};